<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <div class="row">
          <div class="md:tw-w-1/3">
            <fieldset class="tw-h-full">
              <legend>
                {{ pageVocabs + "legends.specifications" | translate }}
              </legend>

              <div class="row">
                <!-- title -->
                <div class="tw-w-full">
                  <form-field
                    [(value)]="model.title"
                    [control]="form?.get('title')"
                    [label]="'common.title'"
                  >
                  </form-field>
                </div>

                <!-- smsText -->
                <div class="tw-w-full">
                  <form-textarea
                    class="tw-w-full m"
                    label="common.smsText"
                    [(value)]="model.smsText"
                    [control]="form?.get('smsText')"
                    [rows]="5"
                  >
                  </form-textarea>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="md:tw-w-2/3">
            <fieldset class="tw-h-full">
              <legend>
                {{ pageVocabs + "legends.help" | translate }}
              </legend>

              <div class="row">
                <!-- alert -->
                <div class="tw-mb-3">
                  <div class="tw-flex tw-items-center tw-mb-2">
                    <span class="text-danger tw-mx-2">*</span>
                    <p
                      class="tw-font-medium tw-m-0 tw-text-gray-700 dark:tw-text-gray-300"
                    >
                      {{ pageVocabs + "messages.description1" | translate }}
                    </p>
                  </div>
                  <div class="tw-flex tw-items-center">
                    <span class="text-danger tw-mx-2">*</span>
                    <p
                      class="tw-font-medium tw-m-0 tw-text-gray-700 dark:tw-text-gray-300"
                    >
                      {{ pageVocabs + "messages.description2" | translate }}
                    </p>
                  </div>
                  <div class="tw-flex tw-items-center">
                    <span class="text-danger tw-mx-2">*</span>
                    <p
                      class="tw-font-medium tw-m-0 tw-text-gray-700 dark:tw-text-gray-300"
                    >
                      {{ pageVocabs + "messages.description3" | translate }}
                    </p>
                  </div>
                  <div class="tw-flex tw-items-center">
                    <span class="text-danger tw-mx-2">*</span>
                    <p
                      class="tw-font-medium tw-m-0 tw-text-gray-700 dark:tw-text-gray-300"
                    >
                      {{ pageVocabs + "messages.description4" | translate }}
                    </p>
                  </div>
                </div>

                <div class="tw-mb-10 tw-rounded">
                  <div
                    class="list-group-item tw-bg-gray-100 dark:tw-bg-dark-200 tw-border dark:tw-border-dark-100 tw-flex tw-justify-start flex-column tw-py-4"
                  >
                    <div class="tw-flex tw-items-center">
                      <span class="text-danger tw-mx-2">*</span>
                      <p
                        class="tw-text-base tw-font-normal dark:tw-text-gray-300"
                      >
                        {{ pageVocabs + "messages.sampleOtp" | translate }}
                      </p>
                    </div>
                    <div
                      class="tw-pt-5 dark:tw-invert-[1] tw-text-left"
                      id="sampleOtp"
                      json-formatter
                      [json]="jsonSampleOtp"
                    ></div>
                  </div>
                </div>
                <!-- json -->
                <div class="tw-mb-10 tw-rounded">
                  <div
                    class="list-group-item tw-bg-gray-100 tw-flex tw-justify-start flex-column tw-py-4 dark:tw-bg-dark-200 tw-border dark:tw-border-dark-100"
                  >
                    <div class="tw-flex tw-items-center">
                      <span class="text-danger tw-mx-2">*</span>
                      <p
                        class="tw-text-base tw-font-normal dark:tw-text-gray-300"
                      >
                        {{
                          pageVocabs + "messages.sampleParameters" | translate
                        }}
                      </p>
                    </div>
                    <div
                      class="tw-pt-5 dark:tw-invert-[1] tw-text-left dir-ltr"
                      id="sampleParameter"
                      json-formatter
                      [json]="sampleParameter"
                    ></div>
                  </div>
                </div>

                <div class="tw-mb-10 tw-rounded">
                  <div
                    class="list-group-item dark:tw-bg-dark-200 tw-bg-gray-100 tw-border dark:tw-border-dark-100 tw-flex tw-justify-start flex-column tw-py-4"
                  >
                    <div class="tw-flex tw-items-center">
                      <span class="text-danger tw-mx-2">*</span>
                      <p
                        class="tw-text-base tw-font-normal dark:tw-text-gray-300"
                      >
                        {{ pageVocabs + "messages.finalMessage" | translate }}
                      </p>
                    </div>
                    <div
                      class="tw-pt-5 dark:tw-invert-[1] tw-text-left"
                      id="finalMessage"
                      json-formatter
                      [json]="finalMessage"
                    ></div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
